export default "__VITE_ASSET__DeTq4nLm__"